<div>
  <div id="general-summary">
    <div id="nodes-container">
      <arm-info-labels infoLabelsId="nodes-connectivity-total"
                   [items]="nodesTotal">
      </arm-info-labels>
      <arm-info-image imageInfoId="nodes-connectivity"
                  [items]="nodesDistribution">
      </arm-info-image>
    </div>

    <div class="fix-clear"></div>

    <div id="peer-connections-container">
      <arm-info-labels infoLabelsId="peer-connections-connectivity-total"
                   [items]="peerConnectionsTotal">
      </arm-info-labels>
      <arm-info-image imageInfoId="peer-connections-connectivity"
                  [items]="peerConnectionsDistribution">
      </arm-info-image>
    </div>

    <div class="fix-clear"></div>

    <div id="connections-container">
      <arm-info-labels infoLabelsId="connections-connectivity-total"
                   [items]="connectionsTotal">
      </arm-info-labels>
      <arm-info-image imageInfoId="connections-connectivity"
                  [items]="connectionsDistribution">
      </arm-info-image>
    </div>
  </div>

  <ac-tabs tabsId="network-map-details-tab-set" #summaryTabs
           (onSelect)="tabSelectHandler($event)">
    <map-summary-graphs *acTab="'General Statistics'; id: 'general-statistics'"
                            [isActive]="activeTabId === 'general-statistics'"></map-summary-graphs>
    <map-summary-top-routes *acTab="'Top 5 Routes'; id: 'top-five-tab'"
                            [isActive]="activeTabId === 'top-five-tab'"></map-summary-top-routes>
    <map-summary-test-route *acTab="'Test Route'; id: 'test-route-tab'"
                            [isActive]="activeTabId === 'test-route-tab'"></map-summary-test-route>
  </ac-tabs>
</div>
